export const THEMES = [
  {
    id: 'biogreen',
    titulo: 'Biogreen',
    descripcion: 'Botones con bordes redondeados en las esquinas, letra pequeña.',
    colorGradient: 'linear-gradient(90deg, #54a04c,#47bd38, #22c55e)'
  },
  {
    id: 'ocean',
    titulo: 'Ocean',
    descripcion: 'Botones con bordes semicirculares y letras medianas.',
    colorGradient: 'linear-gradient(90deg, #0369a1,#0ea5e9, #06b6d4)'
  },
  {
    id: 'sunset',
    titulo: 'Sunset',
    descripcion: 'Botones rectangulares sin redondeados y letras grandes.',
    colorGradient: 'linear-gradient(90deg, #dc2626,#f97316, #a855f7)'
  },
  {
    id: 'forest',
    titulo: 'Forest',
    descripcion: 'Botones rectangulares sin redondeados y letras grandes.',
    colorGradient: 'linear-gradient(90deg, #15803d,#22c55e,#10b981)'
  },
  {
    id: 'purple',
    titulo: 'Purple',
    descripcion: 'Botones rectangulares sin redondeados y letras grandes.',
    colorGradient: 'linear-gradient(90deg, #7c3aed,#a78bfa,#ec4899)'
  },
  {
    id: 'minimal',
    titulo: 'Minimal',
    descripcion: 'Botones rectangulares sin redondeados y letras grandes.',
    colorGradient: 'linear-gradient(90deg, #4b5563,#6b7280,#3b82f6)'
  },
  {
    id: 'tropical',
    titulo: 'Tropical',
    descripcion: 'Botones rectangulares sin redondeados y letras grandes.',
    colorGradient: 'linear-gradient(90deg, #059669,#10b981,#06b6d4)'
  }
];
export const TEMPLATES = [
  {
    id: 'classic',
    titulo: 'Classic',
    descripcion: 'Botones con esquinas redondeadas, letra pequeña.',
    imagenUrl: 'https://res.cloudinary.com/dbnf8c8jf/image/upload/c_crop,g_north_west,h_185,w_267,y_293/Captura_de_pantalla_2026-03-16_-_22.39.36_n8yrk8.png'
  },
  {
    id: 'glass',
    titulo: 'Glass',
    descripcion: 'Botones con bordes semicirculares y letras medianas.',
    imagenUrl: 'https://res.cloudinary.com/dbnf8c8jf/image/upload/c_crop,g_north_west,h_178,w_281,y_337/Captura_de_pantalla_2026-03-16_-_22.44.10_cemwet.png'
  },
  {
    id: 'bold',
    titulo: 'Bold',
    descripcion: 'Botones rectangulares sin redondeados y letras grandes.',
    imagenUrl: 'https://res.cloudinary.com/dbnf8c8jf/image/upload/v1773854042/Captura_desde_2026-03-18_12-12-41_mdme0j.png'
  }
];

export const LAYOUTS = [
  {
    id: 'default',
    titulo: 'Bioliffe',
    descripcion: 'Video en el centro superior, botones en linea horizontal con boton de accion debajo.',
    imagenUrl: 'https://res.cloudinary.com/dbnf8c8jf/image/upload/v1773807147/Captura_desde_2026-03-16_22-52-11_bpqnhl.png'
  },
  {
    id: 'centered',
    titulo: 'Centrado',
    descripcion: 'Video centrado, mayor informacion y botones debajo.',
    imagenUrl: 'https://res.cloudinary.com/dbnf8c8jf/image/upload/v1773807146/Captura_desde_2026-03-16_23-09-58_xrnpie.png'
  },
  {
    id: 'sidebar',
    titulo: 'Lateral',
    descripcion: 'Video a la izquierda, mayor informacion y botones a la derecha.',
    imagenUrl: 'https://res.cloudinary.com/dbnf8c8jf/image/upload/v1773808552/Captura_desde_2026-03-17_23-35-14_rdsmwm.png'
  }
]
